import { useEffect, useState } from "react";
import { api, downloadAsBlob } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { msalInstance } from "../lib/msal";
import DocumentationCard from "../components/DocumentationCard";
import PiHealthCard from "../components/PiHealthCard";
import RfidPiSetupCard from "../components/RfidPiSetupCard";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Textarea } from "../components/ui/textarea";
import { toast } from "sonner";
import { Loader2, Settings as SettingsIcon, MessageSquare, Webhook, Trash2, UserCheck, FileText, CalendarCheck2, CalendarIcon, Plus, PartyPopper, Download, KeyRound, Eye, EyeOff, Cpu, FileDown, Package, Wallet, Clock, Lock, LogOut } from "lucide-react";
import { Checkbox } from "../components/ui/checkbox";
import { Popover, PopoverTrigger, PopoverContent } from "../components/ui/popover";
import { Calendar } from "../components/ui/calendar";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../components/ui/dialog";
import { hr } from "date-fns/locale";
import { format } from "date-fns";

export default function Settings() {
  const { user } = useAuth();
  const [s, setS] = useState({ dean_name: "", secretary_general_name: "", dashboard_message: "", dostavljeno_2: "", dostavljeno_3: "", login_banner_text: "", login_description_text: "", collective_enabled: true, collective_start: "", collective_end: "", extra_holidays: [], collective_reserve_days: 0, attendance_enabled_for_non_admin: true, local_login_enabled: true, collective_reminder_enabled: true });
  const [busy, setBusy] = useState(false);
  const [secBusy, setSecBusy] = useState(false);
  const [dostBusy, setDostBusy] = useState(false);
  const [bannerBusy, setBannerBusy] = useState(false);
  const [msgBusy, setMsgBusy] = useState(false);
  const [collBusy, setCollBusy] = useState(false);
  const [periodBusy, setPeriodBusy] = useState(false);
  const [collStartOpen, setCollStartOpen] = useState(false);
  const [collEndOpen, setCollEndOpen] = useState(false);
  const [holidaysBusy, setHolidaysBusy] = useState(false);
  const [newHoliday, setNewHoliday] = useState({ date: "", name: "" });
  const [newHolidayCalOpen, setNewHolidayCalOpen] = useState(false);
  // Iter51: uvoz praznika za sljedeću godinu
  const [importOpen, setImportOpen] = useState(false);
  const [importYear, setImportYear] = useState(() => new Date().getFullYear() + 1);
  const [importItems, setImportItems] = useState([]);  // [{date, name, selected}]
  const [importBusy, setImportBusy] = useState(false);
  // Iter54: promjena lozinke (samo admin)
  const [pwForm, setPwForm] = useState({ old: "", new1: "", new2: "" });
  const [pwBusy, setPwBusy] = useState(false);
  const [pwShow, setPwShow] = useState({ old: false, new1: false, new2: false });
  // Iter104: RFID Pi state premješten u RfidPiSetupCard komponentu
  // Iter62: deployment guides
  const [deployDocs, setDeployDocs] = useState([]);
  const [webhookUrl, setWebhookUrl] = useState("");
  const [webhookBusy, setWebhookBusy] = useState(false);
  const [webhookTesting, setWebhookTesting] = useState(false);

  useEffect(() => {
    api.get("/settings").then(r => {
      const data = { ...r.data };
      // Iter50: normaliziraj extra_holidays iz [[date,name]] u [{date,name}] za lakši UI render
      if (Array.isArray(data.extra_holidays)) {
        data.extra_holidays = data.extra_holidays.map(h =>
          Array.isArray(h) ? { date: h[0], name: h[1] } : h
        );
      } else {
        data.extra_holidays = [];
      }
      setS(data);
    });
  }, []);
  useEffect(() => {
    api.get("/users/me/webhook").then(r => setWebhookUrl(r.data?.url || "")).catch(() => {});
  }, []);

  const saveDean = async () => {
    setBusy(true);
    try {
      const r = await api.put("/settings", { dean_name: s.dean_name });
      setS(r.data);
      toast.success("Ime dekana spremljeno");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Greška");
    } finally { setBusy(false); }
  };

  const saveSecretaryGeneral = async () => {
    setSecBusy(true);
    try {
      const r = await api.put("/settings", { secretary_general_name: s.secretary_general_name });
      setS(r.data);
      toast.success("Ime glavnog tajnika spremljeno");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Greška");
    } finally { setSecBusy(false); }
  };

  const saveDostavljeno = async () => {
    setDostBusy(true);
    try {
      const r = await api.put("/settings", {
        dostavljeno_2: s.dostavljeno_2,
        dostavljeno_3: s.dostavljeno_3,
      });
      setS(r.data);
      toast.success("Lista primatelja spremljena");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Greška");
    } finally { setDostBusy(false); }
  };

  const saveLoginBanner = async () => {
    setBannerBusy(true);
    try {
      const r = await api.put("/settings", { login_banner_text: s.login_banner_text });
      setS(r.data);
      toast.success("Banner spremljen");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Greška");
    } finally { setBannerBusy(false); }
  };

  const saveMessage = async () => {
    setMsgBusy(true);
    try {
      const r = await api.put("/settings", { dashboard_message: s.dashboard_message });
      setS(r.data);
      toast.success("Poruka na početnoj stranici spremljena");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Greška");
    } finally { setMsgBusy(false); }
  };

  // Iter78: opis na Login screenu (custom banner tekst pod naslovom)
  const [loginDescBusy, setLoginDescBusy] = useState(false);
  const saveLoginDescription = async () => {
    setLoginDescBusy(true);
    try {
      const r = await api.put("/settings", { login_description_text: s.login_description_text || "" });
      setS(r.data);
      toast.success("Opis na login stranici spremljen");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Greška");
    } finally { setLoginDescBusy(false); }
  };

  // Iter48: prekidač "obavezno prihvaćanje kolektivnog godišnjeg odmora"
  const saveCollectiveEnabled = async (next) => {
    setCollBusy(true);
    try {
      const r = await api.put("/settings", { collective_enabled: !!next });
      setS(r.data);
      toast.success(next
        ? "Prihvaćanje kolektivnog je sada OBAVEZNO"
        : "Prihvaćanje kolektivnog je sada ISKLJUČENO — zaposlenici biraju samo vlastite dane");
    } catch (e) {
      setS(prev => ({ ...prev, collective_enabled: !next }));  // revert UI
      toast.error(e.response?.data?.detail || "Greška");
    } finally { setCollBusy(false); }
  };

  // Iter49: spremi razdoblje kolektivnog godišnjeg odmora (start/end ISO strings)
  const saveCollectivePeriod = async () => {
    if (!s.collective_start || !s.collective_end) {
      toast.error("Odaberite oba datuma (početak i kraj)"); return;
    }
    if (s.collective_start > s.collective_end) {
      toast.error("Početak mora biti prije kraja"); return;
    }
    setPeriodBusy(true);
    try {
      const r = await api.put("/settings", {
        collective_start: s.collective_start,
        collective_end: s.collective_end,
      });
      setS(r.data);
      toast.success("Razdoblje kolektivnog godišnjeg odmora spremljeno");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Greška");
    } finally { setPeriodBusy(false); }
  };

  // Iter50: dodavanje / spremanje admin-dodanih praznika
  const normalizeHolidays = (list) => (list || []).map(h =>
    Array.isArray(h) ? { date: h[0], name: h[1] } : { date: h.date, name: h.name }
  );

  // Iter70: rezervacija za novi kolektivni GO
  const [fundBusy, setFundBusy] = useState(false);
  const saveFundSettings = async () => {
    setFundBusy(true);
    try {
      const r = await api.put("/settings", {
        collective_reserve_days: Math.max(0, Number(s.collective_reserve_days ?? 0)),
      });
      setS(r.data);
      toast.success("Postavke fonda spremljene");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Greška");
    } finally { setFundBusy(false); }
  };

  // Iter72: toggle za "Prisutnost" (sakriva rubriku za sve osim admina)
  const [attToggleBusy, setAttToggleBusy] = useState(false);
  const saveAttendanceToggle = async (val) => {
    setAttToggleBusy(true);
    // Optimistic UI update
    setS(prev => ({ ...prev, attendance_enabled_for_non_admin: val }));
    try {
      const r = await api.put("/settings", { attendance_enabled_for_non_admin: val });
      setS(r.data);
      toast.success(val ? "Prisutnost je omogućena svim korisnicima" : "Prisutnost je isključena za sve osim admina");
    } catch (e) {
      // Revert
      setS(prev => ({ ...prev, attendance_enabled_for_non_admin: !val }));
      toast.error(e.response?.data?.detail || "Greška");
    } finally { setAttToggleBusy(false); }
  };

  // Iter73: toggle za lokalni e-mail/lozinka login (kad je isključeno → svi osim admina moraju M365 SSO)
  const [localLoginBusy, setLocalLoginBusy] = useState(false);
  const saveLocalLoginToggle = async (val) => {
    setLocalLoginBusy(true);
    setS(prev => ({ ...prev, local_login_enabled: val }));
    try {
      const r = await api.put("/settings", { local_login_enabled: val });
      setS(r.data);
      toast.success(val
        ? "Lokalna prijava (e-mail/lozinka) je omogućena svim korisnicima"
        : "Lokalna prijava je isključena — samo admin može ući lokalno, ostali koriste Microsoft 365");
    } catch (e) {
      setS(prev => ({ ...prev, local_login_enabled: !val }));
      toast.error(e.response?.data?.detail || "Greška");
    } finally { setLocalLoginBusy(false); }
  };

  // Iter107: toggle za automatski weekly reminder onima koji nisu predali GO zahtjev
  const [reminderBusy, setReminderBusy] = useState(false);
  const saveReminderToggle = async (val) => {
    setReminderBusy(true);
    setS(prev => ({ ...prev, collective_reminder_enabled: val }));
    try {
      const r = await api.put("/settings", { collective_reminder_enabled: val });
      setS(r.data);
      toast.success(val
        ? "Podsjetnici za nepredane zahtjeve su UKLJUČENI (šalju se tjedno)"
        : "Podsjetnici za nepredane zahtjeve su ISKLJUČENI — sustav neće slati automatske podsjetnike");
    } catch (e) {
      setS(prev => ({ ...prev, collective_reminder_enabled: !val }));
      toast.error(e.response?.data?.detail || "Greška");
    } finally { setReminderBusy(false); }
  };

  const saveHolidays = async (next) => {
    setHolidaysBusy(true);
    try {
      const payload = (next || s.extra_holidays || []).map(h => ({ date: h.date, name: h.name || "Praznik" }));
      const r = await api.put("/settings", { extra_holidays: payload });
      setS(prev => ({ ...prev, extra_holidays: normalizeHolidays(r.data.extra_holidays) }));
      toast.success("Praznici spremljeni");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Greška");
    } finally { setHolidaysBusy(false); }
  };

  const addHoliday = () => {
    if (!newHoliday.date || !newHoliday.name) {
      toast.error("Odaberite datum i upišite naziv"); return;
    }
    const next = [...(s.extra_holidays || []), { date: newHoliday.date, name: newHoliday.name }];
    next.sort((a, b) => a.date.localeCompare(b.date));
    setS(prev => ({ ...prev, extra_holidays: next }));
    setNewHoliday({ date: "", name: "" });
    saveHolidays(next);
  };

  const removeHoliday = (date) => {
    const next = (s.extra_holidays || []).filter(h => h.date !== date);
    setS(prev => ({ ...prev, extra_holidays: next }));
    saveHolidays(next);
  };

  // Iter51: uvoz standardnog popisa praznika za zadanu godinu
  const openImport = async () => {
    setImportOpen(true);
    setImportBusy(true);
    try {
      const r = await api.get(`/settings/holidays/suggest`, { params: { year: importYear } });
      // Pre-select sve, osim onih koji već postoje u extra_holidays
      const existing = new Set((s.extra_holidays || []).map(h => h.date));
      setImportItems(r.data.items.map(it => ({ ...it, selected: !existing.has(it.date) })));
    } catch (e) {
      toast.error(e.response?.data?.detail || "Greška pri učitavanju prijedloga");
      setImportOpen(false);
    } finally { setImportBusy(false); }
  };

  const reloadImport = async (year) => {
    setImportYear(year);
    setImportBusy(true);
    try {
      const r = await api.get(`/settings/holidays/suggest`, { params: { year } });
      const existing = new Set((s.extra_holidays || []).map(h => h.date));
      setImportItems(r.data.items.map(it => ({ ...it, selected: !existing.has(it.date) })));
    } catch (e) {
      toast.error(e.response?.data?.detail || "Greška");
    } finally { setImportBusy(false); }
  };

  const applyImport = async () => {
    const selected = importItems.filter(it => it.selected).map(it => ({ date: it.date, name: it.name }));
    if (selected.length === 0) {
      toast.error("Odaberite barem jedan praznik"); return;
    }
    // Merge — postojeći datumi se ne dupliciraju (server normalizira preko set)
    const existing = s.extra_holidays || [];
    const existingDates = new Set(existing.map(h => h.date));
    const merged = [...existing, ...selected.filter(it => !existingDates.has(it.date))];
    merged.sort((a, b) => a.date.localeCompare(b.date));
    await saveHolidays(merged);
    setS(prev => ({ ...prev, extra_holidays: merged }));
    setImportOpen(false);
  };

  const allowed = ["admin", "secretary", "dean"].includes(user.role);
  // Anyone who can RECEIVE pending requests benefits from a webhook
  const canConfigureWebhook = ["manager", "secretary", "dean", "admin", "prodekan"].includes(user.role);
  const isAdmin = user.role === "admin";

  // Iter54: change password handler (samo admin)
  const submitPasswordChange = async () => {
    if (!pwForm.old || !pwForm.new1 || !pwForm.new2) {
      toast.error("Popunite sva polja"); return;
    }
    if (pwForm.new1 !== pwForm.new2) {
      toast.error("Nove lozinke se ne podudaraju"); return;
    }
    if (pwForm.new1.length < 8) {
      toast.error("Nova lozinka mora imati barem 8 znakova"); return;
    }
    if (!/[a-zA-Z]/.test(pwForm.new1) || !/\d/.test(pwForm.new1)) {
      toast.error("Nova lozinka mora sadržavati barem jedno slovo i barem jedan broj"); return;
    }
    if (pwForm.old === pwForm.new1) {
      toast.error("Nova lozinka mora biti različita od stare"); return;
    }
    setPwBusy(true);
    try {
      await api.post("/auth/change-password", {
        old_password: pwForm.old,
        new_password: pwForm.new1,
      });
      toast.success("Lozinka uspješno promijenjena. Druge sesije su odjavljene.");
      setPwForm({ old: "", new1: "", new2: "" });
    } catch (e) {
      const detail = e.response?.data?.detail;
      if (Array.isArray(detail)) {
        toast.error(detail[0]?.msg || "Greška");
      } else {
        toast.error(detail || "Greška");
      }
    } finally { setPwBusy(false); }
  };

  // Iter58: load RFID Pi bundle files list (samo admin/secretary/prodekan)
  // Iter104: rfid-pi/files i rfid-pi/reader-token dohvat premješteni u RfidPiSetupCard
  useEffect(() => {
    if (!["admin", "secretary", "prodekan"].includes(user.role)) return;
    // Iter62: load deployment guides list
    api.get("/admin/deployment-docs")
      .then(r => setDeployDocs(r.data?.docs || []))
      .catch(() => setDeployDocs([]));
  }, [user.role]);

  // Iter104: downloadRfidBundle / downloadRfidFile premješteni u RfidPiSetupCard


  const saveWebhook = async () => {
    setWebhookBusy(true);
    try {
      const r = await api.put("/users/me/webhook", { url: webhookUrl.trim() });
      setWebhookUrl(r.data.url || "");
      toast.success(r.data.url ? "Webhook spremljen" : "Webhook obrisan");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Greška");
    } finally { setWebhookBusy(false); }
  };

  const clearWebhook = async () => {
    setWebhookUrl("");
    setWebhookBusy(true);
    try {
      await api.put("/users/me/webhook", { url: "" });
      toast.success("Webhook obrisan");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Greška");
    } finally { setWebhookBusy(false); }
  };

  const testWebhook = async () => {
    if (!webhookUrl.trim()) { toast.error("Prvo unesite i spremite Webhook URL"); return; }
    setWebhookTesting(true);
    try {
      const r = await api.post("/users/me/webhook/test");
      if (r.data?.ok) toast.success("Testna poruka uspješno poslana ✓");
      else toast.error(`Webhook nije odgovorio (${r.data?.status || r.data?.error || "nepoznato"})`);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Greška");
    } finally { setWebhookTesting(false); }
  };

  // Iter76: SSO session management na ovom uređaju
  const [ssoAccount, setSsoAccount] = useState(null);
  const [ssoTerminating, setSsoTerminating] = useState(false);
  useEffect(() => {
    try {
      const accs = msalInstance.getAllAccounts();
      if (accs.length > 0) setSsoAccount(accs[0]);
    } catch (e) { console.debug("[Settings] MSAL account read failed:", e?.message); }
  }, []);

  const terminateSsoSession = async () => {
    if (!ssoAccount) return;
    if (!window.confirm(
      "Ovo će vas odjaviti iz aplikacije i preusmjeriti na Microsoft logout stranicu. " +
      "Vaša Microsoft sesija u browseru bit će potpuno zatvorena — sljedeća SSO prijava tražit će nove kredencijale.\n\n" +
      "Nastaviti?"
    )) return;
    setSsoTerminating(true);
    try {
      // Prvo obriši našu backend sesiju
      try { await api.post("/auth/logout"); } catch (e) { console.debug("[Settings] backend logout:", e?.message); }
      // Zatim puni Microsoft logout — browser navigira na login.microsoftonline.com/logout,
      // MS invalida sesiju, pa nas vraća na /login (postLogoutRedirectUri).
      await msalInstance.logoutRedirect({
        account: ssoAccount,
        postLogoutRedirectUri: window.location.origin + "/login",
      });
      // Ne stižemo do ovog reda — browser je već navigirao.
    } catch (err) {
      console.error("[Settings] SSO termination failed:", err);
      toast.error(err.message || "Prekid SSO sesije nije uspio");
      setSsoTerminating(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto space-y-6" data-testid="settings-page">
      <div>
        <p className="text-sm text-muted-foreground uppercase tracking-wider">Postavke</p>
        <h1 className="serif text-3xl sm:text-4xl font-semibold">Postavke aplikacije</h1>
      </div>

      {/* Iter77: dokumentacija i vodiči (vidljivo svima s pristupom Postavkama) */}
      <DocumentationCard />

      {/* Iter76: SSO session management — vidljiv svima (osobna sigurnost) */}
      {ssoAccount && (
        <Card data-testid="sso-session-card" className="border-amber-200 bg-amber-50/40">
          <CardHeader>
            <CardTitle className="text-base flex items-center gap-2"><LogOut className="w-4 h-4"/>SSO — sesija na ovom uređaju</CardTitle>
            <p className="text-xs text-muted-foreground">
              Ako ste se prijavili s tuđeg računala ili javnog uređaja, preporučuje se puna odjava iz Microsoft 365.
            </p>
          </CardHeader>
          <CardContent className="space-y-3">
            <div className="text-sm rounded border border-amber-200 bg-white px-3 py-2 space-y-1">
              <div className="text-[11px] text-muted-foreground uppercase tracking-wide">Trenutno prijavljen SSO račun</div>
              <div className="font-mono text-xs" data-testid="sso-current-account">{ssoAccount.username}</div>
              {ssoAccount.name && <div className="text-[11px] text-muted-foreground">{ssoAccount.name}</div>}
            </div>
            <div className="text-[11px] text-muted-foreground space-y-1">
              <p><b>Obična „Odjava" (u gornjem desnom kutu)</b> — briše samo lokalnu sesiju u aplikaciji. Microsoft 365 vas i dalje pamti u browseru; sljedeća SSO prijava proći će „tiho" bez traženja lozinke.</p>
              <p><b>„Prekini SSO sesiju s uređaja" (dolje)</b> — preusmjerava vas na službenu Microsoft logout stranicu koja poništava vašu MS browser sesiju. Sljedeća SSO prijava tražit će nove kredencijale (e-mail + lozinka + MFA).</p>
            </div>
            <Button
              variant="outline"
              onClick={terminateSsoSession}
              disabled={ssoTerminating}
              className="border-amber-400 text-amber-800 hover:bg-amber-100"
              data-testid="terminate-sso-btn"
            >
              {ssoTerminating ? <Loader2 className="w-4 h-4 mr-2 animate-spin"/> : <LogOut className="w-4 h-4 mr-2"/>}
              Prekini SSO sesiju s uređaja
            </Button>
          </CardContent>
        </Card>
      )}

      {allowed ? (
        <>
          <Card data-testid="collective-toggle-card" className="border-accent/40">
            <CardHeader>
              <CardTitle className="text-base flex items-center gap-2"><CalendarCheck2 className="w-4 h-4"/>Kolektivni godišnji odmor</CardTitle>
              <p className="text-xs text-muted-foreground">Glavni prekidač koji kontrolira prikaz kolektivnog odmora kroz cijelu aplikaciju.</p>
            </CardHeader>
            <CardContent className="space-y-3">
              <label className="flex items-start gap-3 cursor-pointer p-3 rounded border bg-secondary/20 hover:bg-secondary/30 transition-colors">
                <Checkbox
                  checked={!!s.collective_enabled}
                  onCheckedChange={(v) => {
                    const next = v === true;
                    setS(prev => ({ ...prev, collective_enabled: next }));
                    saveCollectiveEnabled(next);
                  }}
                  disabled={collBusy}
                  data-testid="collective-enabled-checkbox"
                  className="mt-0.5"
                />
                <div className="flex-1 text-sm">
                  <div className="font-medium">Obavezno prihvaćanje odluke o kolektivnom godišnjem odmoru</div>
                  <p className="text-xs text-muted-foreground mt-1 leading-relaxed">
                    Kada je <b>uključeno</b>: na početnoj stranici i u obrascu za novi zahtjev vidljivo je razdoblje kolektivnog odmora. Zaposlenik <b>ne može predati zahtjev</b> dok ne klikne <i>„Prihvaćam navedeno razdoblje&rdquo;</i> (osim ako ne doda barem jedan vlastiti period u kalendaru).
                  </p>
                  <p className="text-xs text-muted-foreground mt-2 leading-relaxed">
                    Kada je <b>isključeno</b>: obavijest o kolektivnom odmoru se uklanja s početne stranice, a u obrascu zaposlenik bira samo dane iz <i>„Dodatni dani godišnjeg odmora&rdquo;</i>. Nema obaveznog prihvaćanja.
                  </p>
                </div>
              </label>
              <div className={`text-xs px-3 py-2 rounded ${s.collective_enabled ? "bg-accent/15 text-accent-foreground" : "bg-secondary text-muted-foreground"}`} data-testid="collective-enabled-status">
                Status: <b>{s.collective_enabled ? "UKLJUČENO" : "ISKLJUČENO"}</b>
                {collBusy && <Loader2 className="w-3 h-3 inline ml-2 animate-spin"/>}
              </div>

              {/* Iter107: prekidač za weekly reminder onima koji još nisu predali GO */}
              <label className="flex items-start gap-3 cursor-pointer border-t pt-3" data-testid="reminder-toggle-label">
                <input
                  type="checkbox"
                  className="mt-1"
                  checked={!!s.collective_reminder_enabled}
                  disabled={reminderBusy}
                  onChange={(e) => saveReminderToggle(e.target.checked)}
                  data-testid="reminder-toggle-checkbox"
                />
                <div className="space-y-1">
                  <div className="font-medium text-sm">Automatski podsjetnik za nepredane zahtjeve</div>
                  <div className="text-xs text-muted-foreground">
                    Kad je uključeno, sustav <b>jednom tjedno</b> šalje e-mail podsjetnik zaposlenicima koji još nisu predali zahtjev za godišnji odmor — samo unutar razdoblja od 3 tjedna prije kolektivnog. Nakon 4. podsjetnika, obavijest ide i voditelju (eskalacija).
                    Isključite ako su termini dogovoreni izvan sustava pa podsjetnici bune zaposlenike koji ne trebaju predati zahtjev.
                  </div>
                </div>
              </label>
              <div className={`text-xs px-3 py-2 rounded ${s.collective_reminder_enabled ? "bg-accent/15 text-accent-foreground" : "bg-secondary text-muted-foreground"}`} data-testid="reminder-enabled-status">
                Trenutno: <b>{s.collective_reminder_enabled ? "UKLJUČENO (šalje tjedno)" : "ISKLJUČENO (bez podsjetnika)"}</b>
                {reminderBusy && <Loader2 className="w-3 h-3 inline ml-2 animate-spin"/>}
              </div>

              {/* Iter49: razdoblje kolektivnog GO — uređivanje za buduće cikluse (2027, 2028…) */}
              <div className="border-t pt-3 mt-3 space-y-3">
                <div>
                  <Label className="text-sm font-medium flex items-center gap-2"><CalendarIcon className="w-4 h-4"/>Razdoblje kolektivnog godišnjeg odmora</Label>
                  <p className="text-xs text-muted-foreground mt-1">
                    Promijenite ovdje kada se planira sljedeći kolektivni godišnji odmor (npr. za 2027. ciklus). Sustav automatski računa &quot;povratak na posao&quot; kao prvi radni dan nakon završetka.
                  </p>
                </div>
                <div className="grid grid-cols-2 gap-3">
                  <div className="space-y-1">
                    <Label className="text-xs">Početak (prvi dan)</Label>
                    <Popover open={collStartOpen} onOpenChange={setCollStartOpen}>
                      <PopoverTrigger asChild>
                        <Button variant="outline" className="w-full justify-start font-normal" data-testid="coll-start-trigger">
                          <CalendarIcon className="w-4 h-4 mr-2 opacity-60"/>
                          <span>
                            {s.collective_start
                              ? format(new Date(`${s.collective_start}T00:00:00`), "EEE, dd.MM.yyyy.", { locale: hr })
                              : "Odaberite…"}
                          </span>
                        </Button>
                      </PopoverTrigger>
                      <PopoverContent className="p-0 w-auto" align="start">
                        <Calendar
                          mode="single"
                          locale={hr}
                          weekStartsOn={1}
                          selected={s.collective_start ? new Date(`${s.collective_start}T00:00:00`) : undefined}
                          onSelect={(d) => {
                            if (!d) return;
                            const iso = `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}`;
                            setS(prev => ({ ...prev, collective_start: iso }));
                            setCollStartOpen(false);
                          }}
                        />
                      </PopoverContent>
                    </Popover>
                  </div>
                  <div className="space-y-1">
                    <Label className="text-xs">Kraj (zadnji dan)</Label>
                    <Popover open={collEndOpen} onOpenChange={setCollEndOpen}>
                      <PopoverTrigger asChild>
                        <Button variant="outline" className="w-full justify-start font-normal" data-testid="coll-end-trigger">
                          <CalendarIcon className="w-4 h-4 mr-2 opacity-60"/>
                          <span>
                            {s.collective_end
                              ? format(new Date(`${s.collective_end}T00:00:00`), "EEE, dd.MM.yyyy.", { locale: hr })
                              : "Odaberite…"}
                          </span>
                        </Button>
                      </PopoverTrigger>
                      <PopoverContent className="p-0 w-auto" align="start">
                        <Calendar
                          mode="single"
                          locale={hr}
                          weekStartsOn={1}
                          selected={s.collective_end ? new Date(`${s.collective_end}T00:00:00`) : undefined}
                          onSelect={(d) => {
                            if (!d) return;
                            const iso = `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}`;
                            setS(prev => ({ ...prev, collective_end: iso }));
                            setCollEndOpen(false);
                          }}
                        />
                      </PopoverContent>
                    </Popover>
                  </div>
                </div>
                <Button onClick={saveCollectivePeriod} disabled={periodBusy} data-testid="save-coll-period-btn" size="sm">
                  {periodBusy ? <Loader2 className="w-4 h-4 mr-2 animate-spin"/> : null}
                  Spremi razdoblje
                </Button>
                <p className="text-[11px] text-muted-foreground italic">
                  Napomena: promjena utječe na nove zahtjeve, banner na prijavi, broj radnih dana i bulk izdavanje. Postojeća izdana rješenja ostaju nepromijenjena.
                </p>
              </div>
            </CardContent>
          </Card>

          {/* Iter70: rezervacija za novi kolektivni GO */}
          <Card data-testid="fund-settings-card">
            <CardHeader>
              <CardTitle className="text-base flex items-center gap-2"><Wallet className="w-4 h-4"/>Fond — rezervacija za kolektivni GO</CardTitle>
              <p className="text-xs text-muted-foreground">
                Rezervirajte dio fonda svih zaposlenika za novi (drugi) kolektivni godišnji odmor.
              </p>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="space-y-1">
                <Label>Rezervirano dana za novi kolektivni GO</Label>
                <Input type="number" min={0} max={30}
                  value={s.collective_reserve_days ?? 0}
                  onChange={e => setS(prev => ({ ...prev, collective_reserve_days: e.target.value }))}
                  data-testid="reserve-days-input"/>
                <p className="text-[11px] text-muted-foreground">
                  Svakom zaposleniku se ovoliko dana <b>oduzima od raspoloživog</b> za predaju novih zahtjeva
                  (0 = isključeno). Ne mijenja fond ni izdana rješenja — kad odredite drugi kolektivni period i
                  izdate rješenja, vratite na 0.
                </p>
              </div>
              <Button onClick={saveFundSettings} disabled={fundBusy} size="sm" data-testid="save-fund-settings-btn">
                {fundBusy ? <Loader2 className="w-4 h-4 mr-2 animate-spin"/> : null}
                Spremi postavke fonda
              </Button>
            </CardContent>
          </Card>

          {/* Iter72: feature toggle — Prisutnost za sve osim admina (samo admin vidi) */}
          {user?.role === "admin" && (
            <Card data-testid="attendance-toggle-card">
              <CardHeader>
                <CardTitle className="text-base flex items-center gap-2"><Clock className="w-4 h-4"/>Prisutnost — dostupnost korisnicima</CardTitle>
                <p className="text-xs text-muted-foreground">
                  Kontrolira vidljivost rubrike „Prisutnost" (RFID scan, ručna prijava/odjava, povijest) za sve uloge <b>osim administratora</b>. Admin uvijek ima pristup.
                </p>
              </CardHeader>
              <CardContent className="space-y-3">
                <label className="flex items-start gap-3 cursor-pointer">
                  <Checkbox
                    checked={!!s.attendance_enabled_for_non_admin}
                    onCheckedChange={(v) => saveAttendanceToggle(!!v)}
                    disabled={attToggleBusy}
                    data-testid="attendance-toggle-checkbox"
                  />
                  <div className="space-y-1">
                    <div className="text-sm font-medium">
                      Omogući „Prisutnost" zaposlenicima, prodekanima, tajniku i dekanu
                    </div>
                    <p className="text-[11px] text-muted-foreground">
                      Kada je <b>uključeno</b>: svi vide navigacijsku stavku „Prisutnost" i widget rasporeda na Početnoj.
                      Kada je <b>isključeno</b>: svi osim admina gube pristup — stavka u izborniku i widget na Dashboardu se sakrivaju.
                    </p>
                    <p className="text-[11px] text-muted-foreground italic">
                      Trenutno: <b>{s.attendance_enabled_for_non_admin ? "UKLJUČENO" : "ISKLJUČENO"}</b>
                      {attToggleBusy ? <span className="ml-2"><Loader2 className="w-3 h-3 inline animate-spin"/></span> : null}
                    </p>
                  </div>
                </label>
              </CardContent>
            </Card>
          )}

          {/* Iter73: lokalni e-mail/lozinka login toggle — samo admin vidi */}
          {user?.role === "admin" && (
            <Card data-testid="local-login-toggle-card">
              <CardHeader>
                <CardTitle className="text-base flex items-center gap-2"><Lock className="w-4 h-4"/>Prijava — lokalni e-mail i lozinka</CardTitle>
                <p className="text-xs text-muted-foreground">
                  Kada je aplikacija asocirana s vašim Microsoft 365 tenant-om, možete isključiti lokalnu prijavu. Svi korisnici osim <b>administratora</b> tada moraju koristiti Microsoft 365 SSO. Admin uvijek zadržava lokalni pristup kao „fail-safe" — čak i ako SSO privremeno ne radi.
                </p>
              </CardHeader>
              <CardContent className="space-y-3">
                <label className="flex items-start gap-3 cursor-pointer">
                  <Checkbox
                    checked={!!s.local_login_enabled}
                    onCheckedChange={(v) => saveLocalLoginToggle(!!v)}
                    disabled={localLoginBusy}
                    data-testid="local-login-toggle-checkbox"
                  />
                  <div className="space-y-1">
                    <div className="text-sm font-medium">
                      Omogući lokalnu prijavu (e-mail + lozinka) za sve zaposlenike
                    </div>
                    <p className="text-[11px] text-muted-foreground">
                      Kada je <b>uključeno</b>: svi mogu koristiti e-mail/lozinku ILI Microsoft 365 (obje opcije vidljive na prijavi).
                      Kada je <b>isključeno</b>: forma za e-mail/lozinku je sakrivena na prijavi; samo admin može otvoriti diskretnu „Admin lokalna prijava" opciju. Svi ostali korisnici (dekan, tajnik, prodekan, zaposlenici) moraju kroz Microsoft 365.
                    </p>
                    <p className="text-[11px] text-amber-700 bg-amber-50 border border-amber-200 rounded px-2 py-1 mt-1">
                      <b>Preporuka</b>: isključite tek nakon što je SSO uspješno testiran u produkciji (Azure Tenant/Client ID unesen, barem jedan korisnik uspješno prijavljen kroz M365).
                    </p>
                    <p className="text-[11px] text-muted-foreground italic">
                      Trenutno: <b>{s.local_login_enabled ? "UKLJUČENO (obje metode dozvoljene)" : "ISKLJUČENO (samo SSO za sve osim admina)"}</b>
                      {localLoginBusy ? <span className="ml-2"><Loader2 className="w-3 h-3 inline animate-spin"/></span> : null}
                    </p>
                  </div>
                </label>
              </CardContent>
            </Card>
          )}

          {/* Iter50: dodatni praznici za buduće godine (2027+) */}
          <Card data-testid="extra-holidays-card">
            <CardHeader>
              <CardTitle className="text-base flex items-center gap-2"><PartyPopper className="w-4 h-4"/>Dodatni praznici</CardTitle>
              <p className="text-xs text-muted-foreground">
                Bazni popis hrvatskih praznika za 2026. je već u sustavu. Ovdje dodajte praznike za sljedeću godinu (npr. 2027.) čim Hrvatski sabor objavi. Dodani praznici se automatski izuzimaju iz radnih dana kod izračuna godišnjeg i WFH.
              </p>
            </CardHeader>
            <CardContent className="space-y-3">
              {/* Iter51: Uvoz iz baznog popisa */}
              <div className="flex items-center justify-between p-2 rounded border bg-accent/10 border-accent/30">
                <div className="text-xs">
                  <div className="font-medium">Brzo dodavanje praznika za novu godinu</div>
                  <div className="text-muted-foreground">Standardni hrvatski praznici (Uskrs auto-izračunat)</div>
                </div>
                <Button
                  variant="outline"
                  size="sm"
                  onClick={openImport}
                  data-testid="import-holidays-btn"
                >
                  <Download className="w-4 h-4 mr-2"/>
                  Uvezi popis
                </Button>
              </div>
              {/* Lista postojećih */}
              {(s.extra_holidays || []).length === 0 && (
                <p className="text-xs text-muted-foreground italic py-2">Nema dodanih praznika. Bazni 2026. popis je već uključen.</p>
              )}
              {(s.extra_holidays || []).map((h) => (
                <div key={h.date} className="flex items-center gap-2 p-2 rounded border bg-secondary/20" data-testid={`holiday-row-${h.date}`}>
                  <CalendarIcon className="w-4 h-4 opacity-50 flex-shrink-0"/>
                  <div className="flex-1 min-w-0">
                    <div className="text-sm font-medium truncate">{h.name}</div>
                    <div className="text-xs text-muted-foreground">
                      {format(new Date(`${h.date}T00:00:00`), "EEEE, dd.MM.yyyy.", { locale: hr })}
                    </div>
                  </div>
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => removeHoliday(h.date)}
                    disabled={holidaysBusy}
                    data-testid={`holiday-remove-${h.date}`}
                    className="text-destructive hover:text-destructive"
                  >
                    <Trash2 className="w-4 h-4"/>
                  </Button>
                </div>
              ))}

              {/* Dodavanje */}
              <div className="border-t pt-3 mt-3 space-y-2">
                <Label className="text-sm">Dodaj novi praznik</Label>
                <div className="grid grid-cols-[180px_1fr_auto] gap-2 items-end">
                  <Popover open={newHolidayCalOpen} onOpenChange={setNewHolidayCalOpen}>
                    <PopoverTrigger asChild>
                      <Button variant="outline" className="justify-start font-normal" data-testid="new-holiday-date">
                        <CalendarIcon className="w-4 h-4 mr-2 opacity-60"/>
                        {newHoliday.date
                          ? format(new Date(`${newHoliday.date}T00:00:00`), "dd.MM.yyyy.", { locale: hr })
                          : "Datum"}
                      </Button>
                    </PopoverTrigger>
                    <PopoverContent className="p-0 w-auto" align="start">
                      <Calendar
                        mode="single"
                        locale={hr}
                        weekStartsOn={1}
                        selected={newHoliday.date ? new Date(`${newHoliday.date}T00:00:00`) : undefined}
                        onSelect={(d) => {
                          if (!d) return;
                          const iso = `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}`;
                          setNewHoliday(prev => ({ ...prev, date: iso }));
                          setNewHolidayCalOpen(false);
                        }}
                      />
                    </PopoverContent>
                  </Popover>
                  <Input
                    placeholder="Naziv praznika (npr. Nova godina)"
                    value={newHoliday.name}
                    onChange={(e) => setNewHoliday(prev => ({ ...prev, name: e.target.value }))}
                    maxLength={120}
                    data-testid="new-holiday-name"
                  />
                  <Button onClick={addHoliday} disabled={holidaysBusy || !newHoliday.date || !newHoliday.name} data-testid="new-holiday-add-btn">
                    {holidaysBusy ? <Loader2 className="w-4 h-4 animate-spin"/> : <Plus className="w-4 h-4"/>}
                  </Button>
                </div>
              </div>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle className="text-base flex items-center gap-2"><SettingsIcon className="w-4 h-4"/>Dekan fakulteta</CardTitle>
              <p className="text-xs text-muted-foreground">Ime i titula koji se prikazuju kao potpisnik na svim novim PDF rješenjima.</p>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="space-y-2">
                <Label>Puno ime i titula dekana</Label>
                <Input
                  value={s.dean_name || ""}
                  onChange={(e) => setS({ ...s, dean_name: e.target.value })}
                  placeholder="npr. izv. prof. dr. sc. Tomislav Rupčić"
                  data-testid="dean-name-input"
                />
              </div>
              <div className="bg-secondary/50 rounded p-3 text-xs">
                <span className="font-medium">Pregled na PDF-u:</span>
                <div className="serif text-lg text-center mt-2 italic">_______________________________</div>
                <div className="serif text-base text-center font-medium">{s.dean_name || "—"}</div>
              </div>
              <Button onClick={saveDean} disabled={busy} data-testid="save-settings-btn">
                {busy ? <Loader2 className="w-4 h-4 animate-spin mr-2"/> : null}
                Spremi
              </Button>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle className="text-base flex items-center gap-2"><UserCheck className="w-4 h-4"/>Glavni tajnik fakulteta</CardTitle>
              <p className="text-xs text-muted-foreground">Ime koje se automatski upisuje kao &quot;SUGLASAN&quot; potpisnik u zahtjeve za rad na daljinu i &quot;Pripremio/la&quot; na rješenjima godišnjeg odmora. Tajnici mogu pojedinačno override-ati pri svakom slanju.</p>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="space-y-2">
                <Label>Puno ime glavnog tajnika</Label>
                <Input
                  value={s.secretary_general_name || ""}
                  onChange={(e) => setS({ ...s, secretary_general_name: e.target.value })}
                  placeholder="npr. Tomislav Pavković"
                  data-testid="secretary-general-name-input"
                />
              </div>
              <div className="bg-secondary/50 rounded p-3 text-xs">
                <span className="font-medium">Pregled u PDF-u (sekcija „Suglasnost glavnog tajnika fakulteta&rdquo;):</span>
                <div className="serif text-base mt-2"><b>SUGLASAN</b> s odobrenjem rada na daljinu.</div>
                <div className="serif text-sm mt-1">Glavni tajnik fakulteta: <b>{s.secretary_general_name || "—"}</b></div>
              </div>
              <Button onClick={saveSecretaryGeneral} disabled={secBusy} data-testid="save-secretary-general-btn">
                {secBusy ? <Loader2 className="w-4 h-4 animate-spin mr-2"/> : null}
                Spremi
              </Button>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle className="text-base flex items-center gap-2"><FileText className="w-4 h-4"/>Primatelji rješenja godišnjeg odmora</CardTitle>
              <p className="text-xs text-muted-foreground">Stavke 2 i 3 u &quot;Dostavljeno&quot; bloku PDF rješenja. Stavka 1 je uvijek zaposlenik.</p>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="space-y-2">
                <Label>2. Primatelj</Label>
                <Input
                  value={s.dostavljeno_2 || ""}
                  onChange={(e) => setS({ ...s, dostavljeno_2: e.target.value })}
                  placeholder="Služba za pravne i opće poslove i poslove javne nabave, ovdje"
                  data-testid="dostavljeno-2-input"
                />
              </div>
              <div className="space-y-2">
                <Label>3. Primatelj</Label>
                <Input
                  value={s.dostavljeno_3 || ""}
                  onChange={(e) => setS({ ...s, dostavljeno_3: e.target.value })}
                  placeholder="Viši referent za poslove pisarnice i arhiva, ovdje"
                  data-testid="dostavljeno-3-input"
                />
              </div>
              <div className="bg-secondary/50 rounded p-3 text-xs">
                <span className="font-medium">Pregled u PDF-u:</span>
                <div className="serif text-sm mt-2 space-y-1">
                  <div><b>Dostavljeno:</b></div>
                  <div className="pl-3">1. [Zaposlenik], ovdje</div>
                  <div className="pl-3">2. {s.dostavljeno_2 || "—"}</div>
                  <div className="pl-3">3. {s.dostavljeno_3 || "—"}</div>
                </div>
              </div>
              <Button onClick={saveDostavljeno} disabled={dostBusy} data-testid="save-dostavljeno-btn">
                {dostBusy ? <Loader2 className="w-4 h-4 animate-spin mr-2"/> : null}
                Spremi
              </Button>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle className="text-base flex items-center gap-2"><MessageSquare className="w-4 h-4"/>Banner na login stranici</CardTitle>
              <p className="text-xs text-muted-foreground">Tekst koji se prikazuje na dnu prijave (vidljiv prije logiranja). Ako je prazan, automatski se generira iz datuma kolektivnog godišnjeg odmora.</p>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="space-y-2">
                <Label>Tekst bannera</Label>
                <Input
                  value={s.login_banner_text || ""}
                  onChange={(e) => setS({ ...s, login_banner_text: e.target.value })}
                  placeholder="npr. Kolektivni godišnji odmor 2026: 27.07. - 17.08.2026."
                  data-testid="login-banner-input"
                />
                <p className="text-[11px] text-muted-foreground">Format: <code>Naslov: datumi</code> — dio prije dvotočke će biti bijel, dio iza zlatne boje (kao na slici).</p>
              </div>
              <div className="rounded p-4 text-center bg-primary text-primary-foreground">
                {(() => {
                  const previewText = (s.login_banner_text || "Kolektivni godišnji odmor 2026: 27.07. - 17.08.2026.").trim();
                  const m = previewText.match(/^(.*?):\s*(.+)$/);
                  return m
                    ? <span className="serif text-base"><span>{m[1]}: </span><span className="text-accent font-semibold">{m[2]}</span></span>
                    : <span className="serif text-base">{previewText}</span>;
                })()}
              </div>
              <Button onClick={saveLoginBanner} disabled={bannerBusy} data-testid="save-login-banner-btn">
                {bannerBusy ? <Loader2 className="w-4 h-4 animate-spin mr-2"/> : null}
                Spremi
              </Button>
            </CardContent>
          </Card>

          {/* Iter78: konfigurabilan opis na Login screenu (ispod naslova KIF portal zaposlenika) */}
          <Card data-testid="login-desc-card">
            <CardHeader>
              <CardTitle className="text-base flex items-center gap-2"><MessageSquare className="w-4 h-4"/>Opis na login stranici</CardTitle>
              <p className="text-xs text-muted-foreground">
                Duži tekst ispod naslova „KIF portal zaposlenika" na lijevoj strani login stranice.
                Ako ostavite prazno, koristi se ugrađeni default („Osobni portal Kineziološkog fakulteta…").
                Podržava više redova — pritiskom Enter unosite novi red.
              </p>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="space-y-2">
                <Label>Tekst opisa</Label>
                <Textarea
                  rows={4}
                  value={s.login_description_text || ""}
                  onChange={(e) => setS({ ...s, login_description_text: e.target.value })}
                  placeholder="Osobni portal Kineziološkog fakulteta — digitalno upravljanje godišnjim odmorom, radom na daljinu, evidencijom prisutnosti i rješenjima s potpisom dekana. Sve u jednom mjestu."
                  data-testid="login-desc-input"
                />
                <p className="text-[11px] text-muted-foreground">
                  Napomena: naslov <b>„KIF portal zaposlenika."</b> ostaje fiksan — mijenja se samo tekst opisa ispod naslova.
                </p>
              </div>
              {/* Live preview */}
              <div className="rounded-md border border-primary/30 bg-primary text-primary-foreground p-6">
                <div className="serif text-3xl font-semibold mb-3">
                  <span className="text-accent">KIF</span> portal zaposlenika<span className="text-accent">.</span>
                </div>
                <p className="opacity-80 leading-relaxed whitespace-pre-line text-sm" data-testid="login-desc-preview">
                  {(s.login_description_text || "Osobni portal Kineziološkog fakulteta — digitalno upravljanje godišnjim odmorom, radom na daljinu, evidencijom prisutnosti i rješenjima s potpisom dekana. Sve u jednom mjestu.")}
                </p>
              </div>
              <div className="flex gap-2">
                <Button onClick={saveLoginDescription} disabled={loginDescBusy} data-testid="save-login-desc-btn">
                  {loginDescBusy ? <Loader2 className="w-4 h-4 animate-spin mr-2"/> : null}
                  Spremi opis
                </Button>
                <Button
                  variant="outline"
                  onClick={() => setS({ ...s, login_description_text: "" })}
                  disabled={loginDescBusy}
                  data-testid="reset-login-desc-btn"
                >
                  Vrati na default
                </Button>
              </div>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle className="text-base flex items-center gap-2"><MessageSquare className="w-4 h-4"/>Poruka na početnoj stranici</CardTitle>
              <p className="text-xs text-muted-foreground">Tekst koji se prikazuje u glavnom banneru „Kolektivni godišnji odmor” na Dashboardu svih zaposlenika. Možete ga svake godine ažurirati za novi termin kolektivnog odmora.</p>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="space-y-2">
                <Label>Sadržaj poruke</Label>
                <Textarea
                  value={s.dashboard_message || ""}
                  onChange={(e) => setS({ ...s, dashboard_message: e.target.value })}
                  placeholder="Tekst koji se prikazuje zaposlenicima na početnoj stranici."
                  rows={8}
                  data-testid="dashboard-message-input"
                />
                <p className="text-[11px] text-muted-foreground">Savjet: navedite točan datum kolektivnog odmora i datum povratka na posao. Razmaci i novi redovi se zadržavaju kako su unesi.</p>
              </div>
              <Button onClick={saveMessage} disabled={msgBusy} data-testid="save-dashboard-message-btn">
                {msgBusy ? <Loader2 className="w-4 h-4 animate-spin mr-2"/> : null}
                Spremi poruku
              </Button>
            </CardContent>
          </Card>
        </>
      ) : null}

      {canConfigureWebhook && (
        <Card>
          <CardHeader>
            <CardTitle className="text-base flex items-center gap-2">
              <Webhook className="w-4 h-4"/>Teams / Slack obavijesti
            </CardTitle>
            <p className="text-xs text-muted-foreground">
              Postavite osobni <b>Incoming Webhook</b> URL i čim Vam zaposlenik pošalje zahtjev,
              dobit ćete poruku u Teams ili Slack chatu. URL je vidljiv samo Vama.
            </p>
          </CardHeader>
          <CardContent className="space-y-3">
            <div className="space-y-2">
              <Label>Webhook URL</Label>
              <Input
                type="url"
                value={webhookUrl}
                onChange={(e) => setWebhookUrl(e.target.value)}
                placeholder="https://...webhook.office.com/... ili https://hooks.slack.com/services/..."
                data-testid="webhook-url-input"
                autoComplete="off"
                spellCheck={false}
              />
              <p className="text-[11px] text-muted-foreground">
                Dozvoljene domene: <code>*.webhook.office.com</code>, <code>*.logic.azure.com</code> (Teams Workflow),
                <code>hooks.slack.com</code>. URL mora biti HTTPS.
              </p>
            </div>
            <details className="text-[11px] text-muted-foreground bg-secondary/40 rounded p-2">
              <summary className="cursor-pointer font-medium">Kako dobiti URL?</summary>
              <div className="mt-2 space-y-1">
                <p><b>Microsoft Teams:</b> otvorite svoj osobni chat ili kanal → ⋯ → <i>Connectors</i> →
                  <i>Incoming Webhook</i> → unesite naziv „KIF GO/WFH” → <b>Create</b> → kopirajte URL.</p>
                <p><b>Slack:</b> Apps → <i>Incoming Webhooks</i> → odaberite kanal → <b>Add Integration</b> → kopirajte Webhook URL.</p>
              </div>
            </details>
            <div className="flex items-center gap-2 flex-wrap">
              <Button onClick={saveWebhook} disabled={webhookBusy} data-testid="save-webhook-btn">
                {webhookBusy ? <Loader2 className="w-4 h-4 animate-spin mr-2"/> : null}
                Spremi
              </Button>
              <Button variant="outline" onClick={testWebhook} disabled={webhookTesting || !webhookUrl.trim()} data-testid="test-webhook-btn">
                {webhookTesting ? <Loader2 className="w-4 h-4 animate-spin mr-2"/> : null}
                Pošalji testnu poruku
              </Button>
              {webhookUrl && (
                <Button variant="ghost" onClick={clearWebhook} disabled={webhookBusy}
                  className="text-red-600 hover:text-red-700 hover:bg-red-50"
                  data-testid="clear-webhook-btn">
                  <Trash2 className="w-4 h-4 mr-1"/>Obriši
                </Button>
              )}
            </div>
          </CardContent>
        </Card>
      )}

      {/* Iter54: Promjena lozinke (samo admin) */}
      {isAdmin && (
        <Card data-testid="admin-password-card" className="border-amber-400/30 bg-amber-50/30 dark:bg-amber-950/10">
          <CardHeader>
            <CardTitle className="text-base flex items-center gap-2">
              <KeyRound className="w-4 h-4"/>Promjena admin lozinke
            </CardTitle>
            <p className="text-xs text-muted-foreground">
              Ovdje možete promijeniti vlastitu lozinku za prijavu. Nakon promjene, sve ostale aktivne sesije ovog korisnika će biti odjavljene (trenutna sesija ostaje važeća).
            </p>
          </CardHeader>
          <CardContent className="space-y-3 max-w-md">
            <div className="space-y-1">
              <Label className="text-xs">Trenutna lozinka</Label>
              <div className="relative">
                <Input
                  type={pwShow.old ? "text" : "password"}
                  value={pwForm.old}
                  onChange={(e) => setPwForm({ ...pwForm, old: e.target.value })}
                  autoComplete="current-password"
                  data-testid="pw-old"
                  className="pr-10"
                />
                <button
                  type="button"
                  onClick={() => setPwShow(prev => ({ ...prev, old: !prev.old }))}
                  className="absolute right-2 top-1/2 -translate-y-1/2 opacity-60 hover:opacity-100"
                  aria-label="Prikaži lozinku"
                >
                  {pwShow.old ? <EyeOff className="w-4 h-4"/> : <Eye className="w-4 h-4"/>}
                </button>
              </div>
            </div>
            <div className="space-y-1">
              <Label className="text-xs">Nova lozinka <span className="text-muted-foreground">(min 8 znakova, slovo + broj)</span></Label>
              <div className="relative">
                <Input
                  type={pwShow.new1 ? "text" : "password"}
                  value={pwForm.new1}
                  onChange={(e) => setPwForm({ ...pwForm, new1: e.target.value })}
                  autoComplete="new-password"
                  data-testid="pw-new1"
                  className="pr-10"
                />
                <button
                  type="button"
                  onClick={() => setPwShow(prev => ({ ...prev, new1: !prev.new1 }))}
                  className="absolute right-2 top-1/2 -translate-y-1/2 opacity-60 hover:opacity-100"
                  aria-label="Prikaži lozinku"
                >
                  {pwShow.new1 ? <EyeOff className="w-4 h-4"/> : <Eye className="w-4 h-4"/>}
                </button>
              </div>
            </div>
            <div className="space-y-1">
              <Label className="text-xs">Ponovi novu lozinku</Label>
              <div className="relative">
                <Input
                  type={pwShow.new2 ? "text" : "password"}
                  value={pwForm.new2}
                  onChange={(e) => setPwForm({ ...pwForm, new2: e.target.value })}
                  autoComplete="new-password"
                  data-testid="pw-new2"
                  className="pr-10"
                />
                <button
                  type="button"
                  onClick={() => setPwShow(prev => ({ ...prev, new2: !prev.new2 }))}
                  className="absolute right-2 top-1/2 -translate-y-1/2 opacity-60 hover:opacity-100"
                  aria-label="Prikaži lozinku"
                >
                  {pwShow.new2 ? <EyeOff className="w-4 h-4"/> : <Eye className="w-4 h-4"/>}
                </button>
              </div>
              {pwForm.new2 && pwForm.new1 !== pwForm.new2 && (
                <p className="text-xs text-destructive">Lozinke se ne podudaraju</p>
              )}
            </div>
            <Button
              onClick={submitPasswordChange}
              disabled={pwBusy || !pwForm.old || !pwForm.new1 || !pwForm.new2}
              data-testid="pw-submit"
            >
              {pwBusy ? <Loader2 className="w-4 h-4 mr-2 animate-spin"/> : <KeyRound className="w-4 h-4 mr-2"/>}
              Promijeni lozinku
            </Button>
          </CardContent>
        </Card>
      )}

      {/* Iter58 + Iter59: RFID Pi setup + kiosk display (admin/secretary/prodekan) */}
      {["admin", "secretary", "prodekan"].includes(user.role) && (
        <RfidPiSetupCard />
      )}

      {/* Iter102: Pi Health / heartbeat monitor (admin/tajništvo/prodekan/dekan) */}
      {["admin", "secretary", "prodekan", "dean"].includes(user.role) && (
        <PiHealthCard />
      )}

      {/* Iter62: Deployment guides for IT (Azure SSO, Resend email) */}
      {["admin", "secretary", "prodekan"].includes(user.role) && deployDocs.length > 0 && (
        <Card data-testid="deployment-docs-card" className="border-indigo-400/30 bg-indigo-50/30 dark:bg-indigo-950/10">
          <CardHeader>
            <CardTitle className="text-base flex items-center gap-2">
              <FileText className="w-4 h-4"/>IT setup vodiči (za slanje IT službi)
            </CardTitle>
            <p className="text-xs text-muted-foreground">
              Detaljne korak-po-korak upute za konfiguraciju vanjskih servisa.
              Preuzmi Markdown datoteku i proslijedi IT službi ili integratoru.
            </p>
          </CardHeader>
          <CardContent className="space-y-2">
            {deployDocs.map(d => (
              <button
                key={d.name}
                type="button"
                onClick={async () => {
                  try {
                    await downloadAsBlob(`/admin/deployment-docs/${encodeURIComponent(d.name)}`, d.name);
                    toast.success(`Preuzeto: ${d.name}`);
                  } catch (e) {
                    toast.error(e.response?.data?.detail || "Greška");
                  }
                }}
                className="w-full flex items-center gap-3 px-3 py-2.5 rounded border bg-background hover:bg-secondary/40 text-left transition"
                data-testid={`deploy-doc-${d.name}`}
              >
                <FileDown className="w-4 h-4 text-indigo-600 dark:text-indigo-400 shrink-0"/>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium">{d.title}</div>
                  <div className="text-[11px] text-muted-foreground font-mono truncate">
                    {d.name} · {Math.round(d.size_bytes / 102.4) / 10} KB
                  </div>
                </div>
              </button>
            ))}
            <div className="rounded-md bg-indigo-50/60 dark:bg-indigo-950/30 border border-indigo-300/50 p-3 text-xs mt-3">
              <strong className="text-indigo-900 dark:text-indigo-200">Savjet:</strong>{" "}
              <span className="text-muted-foreground">
                Otvori .md datoteku u Notepad-u ili VS Code-u; može se otvoriti i direktno na GitHub-u (renderira lijepo formatirano). Svaki vodič ima gotov template maila za slanje IT-u.
              </span>
            </div>
          </CardContent>
        </Card>
      )}

      {/* Iter51: Import holidays dialog */}
      <Dialog open={importOpen} onOpenChange={setImportOpen}>
        <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2"><Download className="w-5 h-5"/>Uvezi praznike za godinu</DialogTitle>
          </DialogHeader>
          <div className="space-y-3">
            <div className="flex items-center gap-2">
              <Label className="text-sm whitespace-nowrap">Godina:</Label>
              <Input
                type="number"
                min="2000"
                max="2100"
                value={importYear}
                onChange={(e) => {
                  const y = parseInt(e.target.value, 10);
                  if (y >= 2000 && y <= 2100) reloadImport(y);
                  else setImportYear(e.target.value);
                }}
                className="w-28"
                data-testid="import-year-input"
              />
              {importBusy && <Loader2 className="w-4 h-4 animate-spin"/>}
            </div>
            <p className="text-xs text-muted-foreground">
              Standardni hrvatski praznici za odabranu godinu. Uskrs, Uskrsni ponedjeljak i Tijelovo automatski izračunati (Gregorianski Uskrs). Postojeći datumi su unaprijed odznačeni.
            </p>
            <div className="border rounded max-h-96 overflow-y-auto">
              {importItems.map((it, idx) => {
                const existing = (s.extra_holidays || []).some(h => h.date === it.date);
                return (
                  <label
                    key={it.date}
                    className={`flex items-center gap-3 px-3 py-2 border-b cursor-pointer hover:bg-secondary/30 ${existing ? "opacity-60" : ""}`}
                    data-testid={`import-row-${it.date}`}
                  >
                    <Checkbox
                      checked={it.selected}
                      onCheckedChange={(v) => {
                        setImportItems(items => items.map((x, i) => i === idx ? { ...x, selected: v === true } : x));
                      }}
                      disabled={existing}
                    />
                    <div className="flex-1 min-w-0">
                      <div className="text-sm font-medium truncate">{it.name}</div>
                      <div className="text-xs text-muted-foreground">
                        {format(new Date(`${it.date}T00:00:00`), "EEEE, dd.MM.yyyy.", { locale: hr })}
                        {existing && <span className="ml-2 italic">· već postoji</span>}
                      </div>
                    </div>
                  </label>
                );
              })}
              {importItems.length === 0 && !importBusy && (
                <p className="text-sm text-muted-foreground p-3 italic">Nema rezultata</p>
              )}
            </div>
            <div className="flex items-center justify-between text-xs text-muted-foreground">
              <button
                className="underline hover:text-foreground"
                onClick={() => setImportItems(items => items.map(x => ({ ...x, selected: (s.extra_holidays || []).every(h => h.date !== x.date) })))}
                data-testid="import-select-all"
              >
                Odaberi sve nove
              </button>
              <button
                className="underline hover:text-foreground"
                onClick={() => setImportItems(items => items.map(x => ({ ...x, selected: false })))}
                data-testid="import-select-none"
              >
                Odznači sve
              </button>
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setImportOpen(false)}>Odustani</Button>
            <Button onClick={applyImport} disabled={importBusy || importItems.filter(x => x.selected).length === 0} data-testid="import-apply-btn">
              Dodaj odabrane ({importItems.filter(x => x.selected).length})
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
